import React from 'react';
// import {
//   Link
// } from 'react-router-dom'
import NavBar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import appImage from "../components/Hero/app.png";
import './SpecialOffer.css';

const SpecialOffer = () => {
  document.title = 'Special Offer - 1 month subscription';
  return (
    <div>
      <NavBar />
        <div className="" style={{backgroundColor: 'black', padding:50}}>
          <div className="container">
            <h5 className="white-text">Special Offer – 1 Month Subscripton</h5>
            <h5 className="white-text">@ N1,000</h5>
          </div>
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m6">
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h5 className="" style={{fontWeight:'bold', color:'#EE4142'}}>1 month Unilimted Doctor Consultations now for N1,000!</h5>
                <p className="left ">Get umlimited monthly access to Xtendliving call center of highly trained Medical Doctors
                   and Wellness experts ready to give you immediate consultation and advice to your health concerns.<br /><br />
                 With a single subscription of only N1,000, you can speak to a doctor anytime, anywhere and as much as you want for a FULL MONTH! Our call center can be reached for
                  FREE via audio call on 0800xxxxx or by Video Call through our mobile application to provide care for healthy, acute and chronic health conditions.
                  <a target='_blank' rel="noopener noreferrer" href="https://flutterwave.com/pay/6yuhuny6dg7p" id="download-button" className="btn-large" style={{backgroundColor: '#EE4142'}}>Subscribe now</a>
                </p>
              </div>
              <div className="col s12 m6">
                <img src={appImage} className="appImg" alt="chest pain" />
              </div>
            </div>
          </div>
        </div>

        <div className="container" style={{paddingTop: 80}}>
          <div className="section">

            <div className="row">
              <div className="col s12 m4">
                <div className="icon-block">
                  <h2 className="center" style={{color:'#EE4142'}}><i class="fa fa-clock-o custom"></i></h2>
                  <h5 className="center" style={{color:'#EE4142'}}>Available 24/7</h5>

                  <p className="center">Our Doctors are available around the clock, 7 days a week. Our call centre can be reached immediately even when you are out of the country!</p>
                </div>
              </div>

              <div className="col s12 m4">
                <div className="icon-block">
                  <h2 className="center" style={{color:'#EE4142'}}><i class="fa fa-paste custom"></i></h2>
                  <h5 className="center" style={{color:'#EE4142'}}>Your Native Language</h5>

                  <p className="center">All our Doctors speak at least one native language, so wether you want to speak in English, Yoruba, Igbo or Hausa; we have you covered!</p>
                </div>
              </div>

              <div className="col s12 m4">
                <div className="icon-block">
                  <h2 className="center" style={{color:'#EE4142'}}><i class="fa fa-plus custom"></i></h2>
                  <h5 className="center" style={{color:'#EE4142'}}>e-Prescriptions</h5>

                  <p className="center">Receive your ePrescription after your consultation (only if required) and easily pick up your medication at your nearest pharmacy!</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container" style={{paddingTop: 80}}>
          <div className="section">
            <div className="row">
              <div className="col s12 m6">
                <h5 className="" style={{fontWeight:'bold', color: '#EE4142'}}>Conditions we Manage</h5>

                <p className="left ">
                  <ul style={{paddingLeft: 5, fontSize:17}}>
                    <li>Respiratory</li>
                    <li>Musculoskeletal</li>
                    <li>Digestive</li>
                    <li>Ear, Nose & Throat</li>
                    <li>Headaches</li>
                    <li>Malaria</li>
                    <li>Typhoid</li>
                  </ul>
                </p>
                <p className="left">
                  <ul style={{paddingLeft: 5, fontSize:17}}>
                    <li>Eye</li>
                    <li>Chronic Disease</li>
                    <li>Wellness</li>
                    <li>Skin</li>
                    <li>Sexual Health</li>
                    <li>Obstetrics/Gynaecology</li>
                    <li>…..and many more</li>
                  </ul>

                </p>
                <a target='_blank' rel="noopener noreferrer" href="https://flutterwave.com/pay/6yuhuny6dg7p" id="download-button" className="btn-large" style={{backgroundColor: '#EE4142'}}>Get Started</a>
              </div>
              <div className="col s12 m6">
                <img src={appImage} className="appImg" alt="chest pain" />
              </div>
            </div>
          </div>
        </div>

      <Footer />
    </div>
  )
}

export default SpecialOffer;